import React from "react";
import {NavLink } from "react-router-dom";

function TrendingProfile(props) {
    return (<NavLink to="profile.html" className="trending-profile">
        <div className="tp-img">
            <img src={props.coverSrc} alt="" />
        </div>

        {/* Profile Content */}
        <div className="profile-content text-center">
            <div className="profile-top">
                <div className="user-avatar">
                    <img src={props.profileSrc} alt="" />
                    <span className="user-status">
                        <img src={props.statusSrc} className="svg" alt="" />
                    </span>
                </div>

                <h5 className="text-white">{props.heading}</h5>
                <h6>by <span className="c1">{props.authorName}</span></h6>
            </div>
            <div className="profile-bottom">
                {props.description}
            </div>
        </div>
        {/* End Profile Content */}
    </NavLink>);
}

export default TrendingProfile;